export function initMetier() {

	var Page = Barba.BaseView.extend({

		namespace: 'page-metiers',

		onEnter: function() {

			//console.log('Init Metier');

			this.DOM = {};
			this.DOM.hero = this.container.querySelector('.hero');
			this.DOM.expertises = this.container.querySelector('.expertises');
			this.DOM.brand = document.querySelector('header .brand');
			document.querySelector('body > header').classList.add('white');

			this.DOM.players = this.container.querySelectorAll('.player');
			if (this.DOM.players) {
				this.DOM.players.forEach((item) => {
					let player = new Plyr(item);
	      });
			}

			this.pageSy = window.pageYOffset || document.documentElement.scrollTop;
			window.addEventListener('scroll', this.onPageScroll);

		},

		onLeaveCompleted: function() {

			document.querySelector('body > header').classList.remove('white');
			window.removeEventListener('scroll', this.onPageScroll);

		}

	})
	
	Page.onPageScroll = (e) => {
		Page.pageSy = window.pageYOffset || document.documentElement.scrollTop;
		if(Page.pageSy > (Page.DOM.hero.offsetHeight - Page.DOM.brand.offsetTop) && Page.pageSy < (Page.DOM.hero.offsetHeight - Page.DOM.brand.offsetTop + Page.DOM.expertises.offsetHeight)) {
			if (document.querySelector('body > header').classList.contains('white')) document.querySelector('body > header').classList.remove('white');
		} else {
			if (!document.querySelector('body > header').classList.contains('white')) document.querySelector('body > header').classList.add('white');
		};
	}

	Page.init();

}
